// Servicio de gestión de inscripciones para estudiantes

import { get, post } from './api'
import { MESSAGES } from '../utils/constants'

/**
 * Servicio para gestión de inscripciones (Estudiante)
 */
export const inscripcionService = {
  async getProgramasDisponibles() {
    try {
      const response = await get('/estudiante/inscripciones/programas-disponibles')
      
      if (response.data.success) {
        return {
          success: true,
          data: response.data.data,
          message: response.data.message
        }
      } else {
        return {
          success: false,
          message: response.data.message || MESSAGES.ERROR_FETCH
        }
      }
    } catch (error) {
      console.error('Error fetching programas disponibles:', error)
      return {
        success: false,
        message: error.response?.data?.message || MESSAGES.ERROR_FETCH
      }
    }
  },
  async getProgramasDisponiblesAdmin() {
    try {
      const response = await get('/admin/inscripciones/programas-disponibles')
      
      if (response.data.success) {
        return {
          success: true,
          data: response.data.data,
          message: response.data.message
        }
      } else {
        return {
          success: false,
          message: response.data.message || MESSAGES.ERROR_FETCH
        }
      }
    } catch (error) {
      console.error('Error fetching programas disponibles:', error)
      return {
        success: false,
        message: error.response?.data?.message || MESSAGES.ERROR_FETCH
      }
    }
  },
  async verificarHorarios(grupoId) {
    try {
      const response = await post('/estudiante/inscripciones/verificar-horarios', {
        grupo_id: grupoId
      })
      
      if (response.data.success) {
        return {
          success: true,
          tieneConflictos: response.data.tiene_conflictos,
          conflictos: response.data.conflictos || [],
          message: response.data.message
        }
      } else {
        return {
          success: false,
          message: response.data.message || 'Error al verificar horarios'
        }
      }
    } catch (error) {
      console.error('Error verificando horarios:', error)
      return {
        success: false,
        message: error.response?.data?.message || 'Error al verificar horarios'
      }
    }
  },

  async verificarHorariosAdmin(grupoId, estudianteId) {
    try {
      const response = await post('/admin/inscripciones/verificar-horarios', {
        grupo_id: grupoId,
        estudiante_id: estudianteId
      })
      
      if (response.data.success) {
        return {
          success: true,
          tieneConflictos: response.data.tiene_conflictos,
          conflictos: response.data.conflictos || [],
          message: response.data.message
        }
      } else {
        return {
          success: false,
          message: response.data.message || 'Error al verificar horarios'
        }
      }
    } catch (error) {
      console.error('Error verificando horarios:', error)
      return {
        success: false,
        message: error.response?.data?.message || 'Error al verificar horarios'
      }
    }
  },

  async verificarHorariosPrograma(programaId) {
    try {
      const response = await post('/estudiante/inscripciones/verificar-horarios-programa', {
        programa_id: programaId
      })
      
      if (response.data.success) {
        return {
          success: true,
          tieneConflictos: response.data.tiene_conflictos,
          conflictos: response.data.conflictos || [],
          message: response.data.message,
          total_grupos_con_conflicto: response.data.total_grupos_con_conflicto || 0,
          total_grupos_disponibles: response.data.total_grupos_disponibles || 0,
          total_grupos_programa: response.data.total_grupos_programa || 0
        }
      } else {
        return {
          success: false,
          message: response.data.message || 'Error al verificar horarios'
        }
      }
    } catch (error) {
      console.error('Error verificando horarios del programa:', error)
      return {
        success: false,
        message: error.response?.data?.message || 'Error al verificar horarios'
      }
    }
  },

  async verificarHorariosProgramaAdmin(programaId, estudianteId) {
    try {
      const response = await post('/admin/inscripciones/verificar-horarios-programa', {
        programa_id: programaId,
        estudiante_id: estudianteId
      })
      
      if (response.data.success) {
        return {
          success: true,
          tieneConflictos: response.data.tiene_conflictos,
          conflictos: response.data.grupos_con_conflictos || [],
          message: response.data.message,
          total_grupos_con_conflicto: response.data.total_grupos_con_conflicto || 0,
          total_grupos_disponibles: response.data.total_grupos_disponibles || 0,
          total_grupos_programa: response.data.total_grupos_programa || 0
        }
      } else {
        return {
          success: false,
          message: response.data.message || 'Error al verificar horarios'
        }
      }
    } catch (error) {
      console.error('Error verificando horarios del programa:', error)
      return {
        success: false,
        message: error.response?.data?.message || 'Error al verificar horarios'
      }
    }
  },

  async getMisInscripciones(params = {}) {
    try {
      const queryParams = {
        page: params.page || 1,
        per_page: params.per_page || 15
      }

      const response = await get('/estudiante/inscripciones', queryParams)
      
      if (response.data.success) {
        return {
          success: true,
          data: response.data.data,
          message: response.data.message
        }
      } else {
        return {
          success: false,
          message: response.data.message || MESSAGES.ERROR_FETCH
        }
      }
    } catch (error) {
      console.error('Error fetching mis inscripciones:', error)
      return {
        success: false,
        message: error.response?.data?.message || MESSAGES.ERROR_FETCH
      }
    }
  },

  async getInscripcionById(id) {
    try {
      const response = await get(`/estudiante/inscripciones/${id}`)
      
      if (response.data.success) {
        return {
          success: true,
          data: response.data.data,
          message: response.data.message
        }
      } else {
        return {
          success: false,
          message: response.data.message || MESSAGES.ERROR_FETCH
        }
      }
    } catch (error) {
      console.error('Error fetching inscripcion:', error)
      return {
        success: false,
        message: error.response?.data?.message || MESSAGES.ERROR_FETCH
      }
    }
  },

  async crearInscripcion(data) {
    try {
      const response = await post('/estudiante/inscripciones', data)
      
      if (response.data.success) {
        return {
          success: true,
          data: response.data.data,
          message: response.data.message || 'Inscripción realizada exitosamente'
        }
      } else {
        return {
          success: false,
          message: response.data.message || 'Error al realizar inscripción',
          errors: response.data.errors
        }
      }
    } catch (error) {
      console.error('Error creando inscripcion:', error)
      return {
        success: false,
        message: error.response?.data?.message || 'Error al realizar inscripción',
        errors: error.response?.data?.errors
      }
    }
  },

  async crearInscripcionAdmin(data) {
    try {
      const response = await post('/admin/inscripciones', data)
      
      if (response.data.success) {
        return {
          success: true,
          data: response.data.data,
          message: response.data.message || 'Inscripción realizada exitosamente'
        }
      } else {
        return {
          success: false,
          message: response.data.message || 'Error al realizar inscripción',
          errors: response.data.errors
        }
      }
    } catch (error) {
      console.error('Error creando inscripcion:', error)
      return {
        success: false,
        message: error.response?.data?.message || 'Error al realizar inscripción',
        errors: error.response?.data?.errors
      }
    }
  },

  async getMisInscripcionesPorEstudiante(estudianteId) {
    try {
      const response = await get(`/admin/inscripciones/estudiante/${estudianteId}`)
      
      if (response.data.success) {
        return {
          success: true,
          data: response.data.data,
          message: response.data.message
        }
      } else {
        return {
          success: false,
          message: response.data.message || MESSAGES.ERROR_FETCH
        }
      }
    } catch (error) {
      console.error('Error fetching inscripciones por estudiante:', error)
      return {
        success: false,
        message: error.response?.data?.message || MESSAGES.ERROR_FETCH
      }
    }
  },

  async getDescuentosVigentes(programaId){
    try {
      const response = await get(`/admin/descuentos/vigentes`,{programa_id: programaId})
      
      if (response.data.success) {
        return {
          success: true,
          data: response.data.data,
          message: response.data.message
        }
      } else {
        return {
          success: false,
          message: response.data.message || MESSAGES.ERROR_FETCH
        }
      }
    } catch (error) {
      console.error('Error fetching descuentos vigentes:', error)
      return {
        success: false,
        message: error.response?.data?.message || MESSAGES.ERROR_FETCH
      }
    }
  }
}
